import React, {useEffect, useState} from 'react';
import {Badge, Col, Row} from 'reactstrap';
import {useDispatch, useSelector} from "react-redux";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, } from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../../accents/BRCustomizedTooltip";
import {
    addBRSubscription, deactivateCustomerSubscription, updateBRSubscriptionDates,
    updateBRSubscriptionDeactivate, updateBRSubscriptionEndDate,
    updateBRSubscriptionLevel, updateBRSubscriptionStartDate,
} from "../../../../actions";
import {
    bbArrayOfActiveSubscriptions,
    bbDangerousDateToBBApiDate,
    bbDangerousStringToDate,
    bbDoesCustomerHaveAccessToSubscription,
    bbFormattedDateString
} from "../../../../util/bbHelpers";
import Button from "@material-ui/core/Button";
import {KeyboardDatePicker} from "@material-ui/pickers";
import IntlMessages from "../../../../util/IntlMessages";
import CloseIcon from "@material-ui/icons/Close";
import {customersData} from "../../../../app/routes/dashboard/routes/settingsSubscription/tempTestDataForCustomers";

const BRSubscriptionControlWidget = ({customerId= null,
                                         subscriptionTypeName='',
                                         subscriptionType= 0,
                                     }) => {

    const { customers } = useSelector(({customer})=> customer);
    // const customers = customersData;
    const customer = customers ? customerId ? customers[customerId]: customers[customerId] : null

    const dispatch = useDispatch();
    const now = Date.now();

    const subscriptionsArray = customer && customer.Subscriptions && Object.values(customer.Subscriptions);
    const subscriptions = customer
        && Array.isArray(subscriptionsArray)
        && subscriptionsArray
            .filter((sub)=> sub
                && sub.subscription_type
                && sub.subscription_type.id
                && sub.subscription_type.id === subscriptionType)

    const activeSubsOnly = subscriptions
        && subscriptions
            .filter((sub)=> !sub.subscription_end || (sub.subscription_end && bbDangerousStringToDate(sub.subscription_end) > now));

    const subscriptionsProvidedBy = activeSubsOnly && Array.isArray(activeSubsOnly) && activeSubsOnly.filter((sub)=> sub.customer_provided);
    const subscriptionsNoOneProvided =activeSubsOnly && Array.isArray(activeSubsOnly) && activeSubsOnly.filter((sub)=> !sub.customer_provided);
    const subscriptionsSelfManaged = activeSubsOnly && Array.isArray(activeSubsOnly) && activeSubsOnly.filter((sub)=> sub.stripe_subscription_id)

    const subscriptionsNotProvidedByAndNotSelfManaged = activeSubsOnly && Array.isArray(activeSubsOnly) && activeSubsOnly.filter((sub)=> !sub.stripe_subscription_id && !sub.customer_provided);

    const hasSubscriptionsProvidedBy = subscriptionsProvidedBy && Array.isArray(subscriptionsProvidedBy) && subscriptionsProvidedBy.length > 0;
    const hasOwnSubscription = subscriptionsNoOneProvided && Array.isArray(subscriptionsNoOneProvided) && subscriptionsNoOneProvided.length >0;
    // const hasSelfManagedSubs = subscriptionsSelfManaged && Array.isArray(subscriptionsSelfManaged) && subscriptionsSelfManaged.length > 0;
    const hasSelfManagedSubs = subscriptionType === 2 ? customer.BRBManagedByStripe : subscriptionType === 1 ? customer.BRPManagedByStripe : null;
    const hasSubsNotProvidedAndNotSelfManaged = subscriptionsNotProvidedByAndNotSelfManaged && Array.isArray(subscriptionsNotProvidedByAndNotSelfManaged)
        && subscriptionsNotProvidedByAndNotSelfManaged.length > 0;

    const [open, setOpen] = useState(false);

    const stromboli = customer && customer.Stromboli && customer.Stromboli["Service Active"] === "1";
    const cirtEndDate = !!stromboli && customer["Subscription EndDate"] ? bbDangerousStringToDate(customer["Subscription EndDate"]) : null;

    // const subToDisplay = activeSubsOnly && activeSubsOnly.length > 1 ?
    //


    // const [active, setActive] = useState(subscriptionType !== 3 ? subscriptions.length > 0 : ( stromboli && customer["Subscription Active"]) );
    const [active, setActive] = useState(subscriptionType !== 3 ? bbDoesCustomerHaveAccessToSubscription(customer, subscriptionType)
        : ( stromboli && customer.Stromboli && customer.Stromboli["Service Active"] !== "0" && (cirtEndDate && cirtEndDate > now)));
    const [newLevel, setNewLevel] = useState(activeSubsOnly
        && activeSubsOnly.length > 0
        && activeSubsOnly[0]
        && activeSubsOnly[0].subscription_level
        && activeSubsOnly[0].subscription_level.id
            ? activeSubsOnly[0].subscription_level.id : null);

    const [openUpdate, setOpenUpdate] = useState(false);
    const [updateOption, setUpdateOption] = useState(null);
    const [subIdToUpdate, setSubIdToUpdate] = useState(null);

    const [openDeactivate, setOpenDeactivate] = useState(false);
    const [deactivateOption, setDeactivateOption] = useState(null);
    const [subIdToDeactivate, setSubIdToDeactivate] = useState(null);

    const [openAdd, setOpenAdd] = useState(false)
    const [addOption, setAddOption] = useState(null);

    const [openUpdateDate, setOpenUpdateDate] = useState(false);
    const [subIdToUpdateDate, setSubIdToUpdateDate] = useState(null);

    const [subscription_start, set_subscription_start] = useState(null);
    const [subscription_end, set_subscription_end] = useState(null);

    useEffect(()=>{
        // setActive(subscriptionType !== 3 ? subscriptions.length > 0 : ( stromboli && customer["Subscription Active"]));
        setActive(subscriptionType !== 3
            ? bbDoesCustomerHaveAccessToSubscription(customer, subscriptionType)
            : (stromboli && customer.Stromboli && customer.Stromboli["Service Active"] !== "0"))
        setNewLevel( subscriptions
        && subscriptions.length > 0
        && subscriptions[0]
        && subscriptions[0].subscription_level
        && subscriptions[0].subscription_level.id
            ? subscriptions[0].subscription_level.id : null)
    }, [dispatch, subscriptions])

    function handleOnClick(option){

        const subLevelId = option && option.subLevelId;

        if(active && hasSubsNotProvidedAndNotSelfManaged && subLevelId !==0){
            handleClose()
            setOpenUpdate(true);
            setUpdateOption(option);

        } else if (active && hasSubsNotProvidedAndNotSelfManaged && subLevelId === 0){
            handleClose()
            setOpenDeactivate(true);
            setDeactivateOption(option);
            // setSubIdToDeactivate()

        } else if (!active || (hasSubsNotProvidedAndNotSelfManaged && !hasMultipleSubs)){
            handleClose();
            setOpenAdd(true);
            setAddOption(option);
        }
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseUpdate = () => {
        setOpenUpdate(false);
    };

    const handleConfirmUpdate = (option) => {

        const optionSubLevelId = option && option.subLevelId;
        const subToUpdate = subscriptionsNotProvidedByAndNotSelfManaged &&  subscriptionsNotProvidedByAndNotSelfManaged
            .find(x=> x.subscription_level.id !== optionSubLevelId);

        if(subToUpdate){
            try {
                dispatch(updateBRSubscriptionLevel(customerId, subToUpdate.id, optionSubLevelId));
                setNewLevel(optionSubLevelId)
                handleCloseUpdate();
            } catch (e) {
                console.warn(e);
                return null
            }
        } else{
            return null
        }


    }

    const handleCloseDeactivate = () => {
        setOpenDeactivate(false);
    };

    const handleConfirmDeactivate = (option) => {
        // console.log("updateBRsbscriptionDeactive dispatched, send: ", customerId, option.subscriptionId)

        const subToDeactivate = subscriptionsNotProvidedByAndNotSelfManaged && subscriptionsNotProvidedByAndNotSelfManaged[0];

        if(subscriptionType === 1 || subscriptionType === 2){
            try{
                dispatch(updateBRSubscriptionDeactivate(customerId, subToDeactivate.id));
                setActive(!active)
                handleCloseDeactivate();
            } catch (e) {
                console.warn(e);
                return null
            }
            // } else if(subscriptionType === 3){
            //     try{dispatch(deactivateCustomerSubscription(
            //         {customerId: customerId}
            //     ))
            //     }catch (e) {
            //         console.warn(e);
            //         return null
            //     }
        } else{
            return null;
        }
    }

    const handleCloseAdd = () => {
        setOpenAdd(false);
    };

    const handleConfirmAdd = (option, subscriptionStart, subscriptionEnd) => {
        // console.log("addBRsubscription dispatched, sent", customerId, option.subType, option.subLevelId, bbDangerousDateToBBApiDate(subscriptionStart), bbDangerousDateToBBApiDate(subscriptionEnd))

        if(subscriptionStart && subscriptionEnd){
            try {
                dispatch(addBRSubscription(customerId, option.subType, option.subLevelId, bbDangerousDateToBBApiDate(subscriptionStart), bbDangerousDateToBBApiDate(subscriptionEnd)))
                setActive(!active)
                setNewLevel(option.subLevelId)
            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }

        handleCloseAdd();

    }

    const handleClickUpdateDates = (subscriptionId) => {
        handleClose();
        setSubIdToUpdateDate(subscriptionId);
        const customerSubscriptionsObj = customer && customer.Subscriptions;
        const customerSubInView = customer && customerSubscriptionsObj && customerSubscriptionsObj[subscriptionId];
        // console.log("handleClickUpdateDates triggered", subscription_start, subscription_end, subIdToUpdateDate, "before set dates");
        set_subscription_start(customerSubInView.subscription_start);
        set_subscription_end(customerSubInView.subscription_end
            ? customerSubInView.subscription_end
            : new Date(new Date().setMonth(new Date().getMonth() + 1)));
        // console.log("handleClickUpdateDates triggered", subscription_start, subscription_end, subIdToUpdateDate, "after set dates");
        setOpenUpdateDate(true);
    }

    const handleCloseUpdateDate = () => {
        setOpenUpdateDate(false);
    }

    const handleConfirmUpdateDate = (subscriptionStart, subscriptionEnd) => {
        // console.log("handleConfirmUpdateDate triggered", subscriptionStart, subscriptionEnd, subIdToUpdateDate);
        if( subscriptionStart || subscriptionEnd){
            console.log(bbDangerousDateToBBApiDate(subscriptionStart), "=== subscriptionStart", subscriptionEnd, bbDangerousDateToBBApiDate(subscriptionEnd), "=== subscriptionEnd")
            try{
                // dispatch(updateBRSubscriptionStartDate(customerId, subIdToUpdateDate, bbDangerousDateToBBApiDate(subscriptionStart)));
                //
                // dispatch(updateBRSubscriptionEndDate(customerId, subIdToUpdateDate, bbDangerousDateToBBApiDate(subscriptionEnd)));
                dispatch(updateBRSubscriptionDates(customerId, subIdToUpdateDate, bbDangerousDateToBBApiDate(subscriptionStart),bbDangerousDateToBBApiDate(subscriptionEnd)));

                handleCloseUpdateDate();
            } catch (e) {
                console.warn(e);
                return null
            }
        } else {
            return null;
        }

    }

    // console.log(subscriptions, "== subscriptions", customers[customer].Subscriptions["1f49877a-0050-416d-85d3-95e1b9e7316c"].subscription_start, "== customer.Subscriptions")

    open && console.log("subsriptions for", customer["Customer Short Name"], subscriptions);

    const hasMultipleSubs = subscriptions && subscriptions.length > 1

    const subLevel = subscriptions && subscriptions[0]
        ? subscriptions[0].subscription_level.name
        : ""

    const subLevels =  hasMultipleSubs
        ? subscriptions
            .filter((sub)=> !sub.subscription_end || (sub.subscription_end && bbDangerousStringToDate(sub.subscription_end) > now))
            .map((sub)=> sub.subscription_level.name) : null ;

    let subId;

    // if(hasSubscriptionsProvidedBy && hasOwnSubscription){
    //     subId = subscriptionsNoOneProvided && subscriptionsNoOneProvided[0] && subscriptionsNoOneProvided[0].id;
    // } else if(hasSubscriptionsProvidedBy && !hasOwnSubscription){
    //     subId = null;
    // } else if(!hasSubscriptionsProvidedBy && hasOwnSubscription){
    //     subId = subscriptionsNoOneProvided && subscriptionsNoOneProvided[0] && subscriptionsNoOneProvided[0].id;
    // } else{
    //     subId = null;
    // }
    // const subId = subscriptions && subscriptions[0] ? subscriptions[0].id : null;

    const subIds = hasMultipleSubs ?  subscriptions.map((sub)=> sub.id) : null;


    const optionsBiz = [
        {subscriptionName: "Business", subType: 2, subLevelName: "free", subLevelId:10, },
        {subscriptionName: "Business", subType: 2, subLevelName: "trial", subLevelId: 5, },
        {subscriptionName: "Business", subType: 2, subLevelName: "lite", subLevelId: 6, },
        {subscriptionName: "Business", subType: 2, subLevelName: "pro", subLevelId: 7, },
        {subscriptionName: "Business", subType: 2, subLevelName: "premium", subLevelId: 11,},
        {subscriptionName: "Cancel", subType: 2, subLevelName: "Subscription", subLevelId: 0, },
    ]

    const optionsPort = [
        {subscriptionName: "Portfolio", subType: 1, subLevelName: "trial", subLevelId: 1, },
        {subscriptionName: "Portfolio", subType: 1, subLevelName: "starter", subLevelId: 2,  },
        {subscriptionName: "Portfolio", subType: 1, subLevelName: "pro", subLevelId: 3, },
        {subscriptionName: "Portfolio", subType: 1, subLevelName: "premium", subLevelId: 4, },
        {subscriptionName: "Cancel", subType: 1, subLevelName: "Subscription", subLevelId: 0,  },
    ]

    const optionsCIRT = [
        {subscriptionName: "No Choices Currently", subType: 3, subLevelName: " Available for CIRT", subLevelId: 0 },
        {subscriptionName: "Cancel", subType: 3, subLevelName: "Subscription", subLevelId: 0 },
    ];

    let options;

    if(subscriptionType === 2){
        options = optionsBiz
    } else if(subscriptionType === 1){
        options = optionsPort
    } else if(subscriptionType === 3){
        options = optionsCIRT
    } else{
        options= [];
    }


    const levelNames = {1: "trial", 2: "starter", 3: "pro", 4: "premium", 5: "trial", 6: "lite", 7: "pro", 10: "free", 11: "premium"};

    (!active || (hasSubscriptionsProvidedBy && !hasMultipleSubs)) && options.pop();


    // console.log("Start",subscription_start,"End", subscription_start)
    return(
        <div className="p-2 text-center">
            <Tooltip title={"Click to open subscription options"}>
                    <span><Badge color={active ? "primary" : "lighter-gray"}
                                 type="Button"
                                 onClick={handleClickOpen}
                                 variant="contained"
                    >
                        {subscriptionTypeName}  {(active && newLevel) && levelNames[newLevel]}
                    </Badge></span>
            </Tooltip>

            <Dialog
                open={open}
                fullWidth={false}
                maxWidth={"md"}
                onClose={handleClose}
                className="form-dialog-title text-center"
            >

                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {active
                        ? `Change Subscription for ${customer["Customer Short Name"]}`
                        : `Activate A Subscription for ${customer["Customer Short Name"]}`}
                    <IconButton
                        onClick={()=>setOpen(false)}
                        className={"close"}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>

                <DialogContent className="text-center select-level">
                    <div>
                        <Row>
                            {/*<ul className="text-center">*/}
                                {options.map((option, index)=>{
                                    let color;
                                    if(active && newLevel && hasMultipleSubs && subLevels.includes(option.subLevelName)){
                                        color = "primary"
                                    } else if(active && newLevel && option.subLevelId === newLevel){
                                        color = "primary"
                                    } else{
                                        color = "lighter-gray"
                                    }
                                    return(
                                        <Col className={"m-0 p-0"} key={index}>
                                            <Badge
                                                value={option.subLevelId}
                                                onClick={()=> handleOnClick(option)}
                                                type="Button"
                                                color={color}
                                                className={`p-1 m-1 col-${options.length / 12}`}
                                                // disabled={}
                                            >
                                                {option.subscriptionName} {option.subLevelName}
                                            </Badge>
                                        </Col>

                                        // </li>
                                    )})}
                            {/*</ul>*/}
                        </Row>

                    </div>
                    <div>
                    {subscriptions &&
                    (<div>
                        <hr/>
                    </div>)}
                    {hasSubscriptionsProvidedBy && <p><em>Subscriptions provided by another company can not be added, deleted, or updated.</em></p>}
                    {subscriptions && subscriptions.map((sub, index)=>
                        <Row key={sub.id} className="row text-center m-1 p-1">
                            <Col key={index}>
                                        <span>{sub.subscription_end && bbDangerousStringToDate(sub.subscription_end) < now
                                            ? <em><small>Inactive--&nbsp;</small></em>
                                            : null}
                                            {sub.subscription_level.name}
                                            {sub.stripe_subscription_id && hasSelfManagedSubs
                                                ? <p><small><em>Self Managed</em></small></p>
                                                : null}
                                            {sub.customer_provided
                                                ? <p><small><em>{`Provided By: ${customers[sub.customer_provided].CustomerName}`}</em></small></p>
                                                : null}

                                        </span>
                            </Col>

                            <Col>
                                    <p>Start Date: {bbFormattedDateString(sub.subscription_start, "short")}</p>
                            </Col>

                            <Col>
                                    <p>End Date: {sub.subscription_end ? bbFormattedDateString(sub.subscription_end, "short") : "--"}</p>
                            </Col>

                            <Col className="text-center">
                                    <small>
                                        <Button variant="contained"
                                                onClick={()=>handleClickUpdateDates(sub.id)}
                                                size="small"
                                                disabled={sub.customer_provided
                                                || (sub.subscription_end && bbDangerousStringToDate(sub.subscription_end) < now)
                                                || hasSelfManagedSubs}
                                            // disableElevation={true}
                                        >Update Dates</Button>
                                    </small>
                            </Col>
                        </Row>
                    )}
                    </div>

                </DialogContent>
            </Dialog>


            <Dialog open={openUpdate}
                    fullWidth={false}
                    maxWidth={"md"}
                    onClose={handleCloseUpdate}
                    className="form-dialog-title text-center">
                <DialogTitle>This Will Update An Existing Subscription
                    <IconButton
                        onClick={handleCloseUpdate}
                        className={"close"}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent onClose={handleCloseUpdate}>
                    <h3>Are you sure you want to update {customer["Customer Short Name"]}'s Subscription?</h3>
                    <br/>
                    {updateOption &&<p>You've selected {updateOption.subscriptionName} {updateOption.subLevelName}</p>}
                    <DialogActions>
                        <Button onClick={() => handleConfirmUpdate(updateOption)}>Confirm</Button>
                        <Button onClick={handleCloseUpdate}>Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Dialog open={openDeactivate}
                    fullWidth={false}
                    maxWidth={"md"}
                    onClose={handleCloseDeactivate}
                    className="form-dialog-title text-center">
                <DialogTitle >
                    This will deactivate an existing subscription
                    <IconButton
                        onClick={handleCloseDeactivate}
                        className={"close"}>
                        <CloseIcon/>
                    </IconButton></DialogTitle>
                <DialogContent onClose={handleCloseDeactivate}>
                    <h3>Are you sure you want to deactivate {customer["Customer Short Name"]}'s Subscription?</h3>
                    <DialogActions>
                        <Button onClick={()=> handleConfirmDeactivate(deactivateOption, subIdToDeactivate)}>Confirm</Button>
                        <Button onClick={handleCloseDeactivate}>Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Dialog open={openAdd}
                    fullWidth={false}
                    maxWidth={"md"}
                    onClose={handleCloseAdd}
                    className="form-dialog-title text-center">
                <DialogTitle >
                    This Will Add A Subscription To A Customer
                    <IconButton
                        onClick={handleCloseAdd}
                        className={"close"}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent onClose={handleCloseAdd}>
                    <KeyboardDatePicker
                        margin="normal"
                        id="subscription_start"
                        name="subscription_start"
                        label={<IntlMessages id="appModule.newClient.subscription_start"/>}
                        required
                        format="MM/DD/yyyy"
                        value={subscription_start}
                        minDate={new Date(Date.now())}
                        onChange={(date) => set_subscription_start(date)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    <KeyboardDatePicker
                        margin="normal"
                        id="subscription_end"
                        name="subscription_end"
                        label={<IntlMessages id="appModule.newClient.subscription_end"/>}
                        required
                        format="MM/DD/yyyy"
                        value={subscription_end}
                        minDate={new Date(new Date().setMonth(new Date().getMonth() + 1))}
                        onChange={(date) => set_subscription_end(date)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    {addOption &&
                    <h3>Are you sure you want to add {addOption.subscriptionName} {addOption.subLevelName} to {customer["Customer Short Name"]}?</h3>
                    }
                    {addOption && console.log(bbFormattedDateString(subscription_start, "shortFullMonth"), bbFormattedDateString(subscription_end, "shortFullMonth"))}

                    <DialogActions>
                        <Button onClick={()=> handleConfirmAdd(addOption, subscription_start, subscription_end)}>Confirm</Button>
                        <Button onClick={handleCloseAdd}>Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

            <Dialog open={openUpdateDate}
                    fullWidth={false}
                    maxWidth={"md"}
                    onClose={handleCloseUpdateDate}
                    className="form-dialog-title text-center">
                <DialogTitle >
                    Change the Start/End Date for a customer's subscription
                    <IconButton
                        onClick={handleCloseUpdateDate}
                        className={"close"}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent onClose={handleCloseUpdateDate}>
                    <KeyboardDatePicker
                        margin="normal"
                        id="subscription_start"
                        name="subscription_start"
                        label={<IntlMessages id="appModule.newClient.subscription_start"/>}
                        required
                        format="MM/DD/yyyy"
                        value={subscription_start}
                        minDate={subscription_start ? subscription_start : new Date(Date.now())}
                        onChange={(date) => set_subscription_start(date)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    {/*{subIdToUpdateDate && console.log(subIdToUpdateDate, new Date(customer.Subscriptions[subIdToUpdateDate].subscription_start), new Date())}*/}
                    <KeyboardDatePicker
                        margin="normal"
                        id="subscription_end"
                        name="subscription_end"
                        label={<IntlMessages id="appModule.newClient.subscription_end"/>}
                        required
                        format="MM/DD/yyyy"
                        value={subscription_end}
                        // minDate={new Date()}
                        onChange={(date) => set_subscription_end(date)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                    <br/>
                    {(subscription_start || subscription_end) &&
                    <h3>Are you sure you want to change the subscription's active dates to be from <br/>
                        {Object.prototype.toString.call(subscription_start) === '[object Object]'
                            ? bbFormattedDateString(subscription_start.toString(), "shortFullMonth")
                            : bbFormattedDateString(subscription_start, "shortFullMonth")} to&nbsp;
                        {Object.prototype.toString.call(subscription_end) === '[object Object]'
                            ? bbFormattedDateString(subscription_end.toString(), "shortFullMonth")
                            : bbFormattedDateString(subscription_end, "shortFullMonth")} for&nbsp;
                        {customer["Customer Short Name"]}?
                    </h3>
                    }
                    {/*{subIdToUpdateDate && console.log(bbFormattedDateString(subscription_start, "shortFullMonth"), bbFormattedDateString(subscription_end, "shortFullMonth"))}*/}
                    <DialogActions>
                        <Button onClick={()=> handleConfirmUpdateDate(subscription_start, subscription_end)}>Confirm</Button>
                        <Button onClick={handleCloseUpdateDate}>Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

        </div>
    )
}

export default BRSubscriptionControlWidget;
